import React, { useCallback } from 'react';

import { InviteErrorFlag } from '@atlassian/invite-prompt';

import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer.ts';

export const useInviteErrorFlag = (flags?: FlagsStateContainer) => {
	return useCallback(() => {
		const dismiss = (id: string | number) => flags?.hideFlag(id);

		flags?.showFlag({
			customComponent: (props) => <InviteErrorFlag {...props} id={props.id} onDismiss={dismiss} />,
		});
	}, [flags]);
};
